import { useFrame } from '@react-three/fiber';
import React, { FC, useMemo } from 'react';
import { CanvasTexture, UVMapping, RepeatWrapping, NearestFilter } from 'three';
import { Vector } from '../types';

const getCanvas = (
  [width, height]: [number, number],
  draw: (ctx: CanvasRenderingContext2D) => boolean,
) => {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

  const texture = new CanvasTexture(
    ctx.canvas,
    UVMapping,
    RepeatWrapping,
    RepeatWrapping,
    NearestFilter,
    NearestFilter,
  );

  return {
    texture,
    step: () => {
      if (draw(ctx)) texture.needsUpdate = true;
    },
  };
};

export type Canvas2DProps = {
  size: [number, number];
  canvasSize?: [number, number];
  position: Vector;
  rotation?: Vector;
  draw: (ctx: CanvasRenderingContext2D) => boolean;
  meshRef?: (el: any) => void;
  visible?: boolean;
  opacity?: number;
};

export const Canvas2D: FC<Canvas2DProps> = ({
  size,
  canvasSize = size,
  position,
  draw,
  meshRef,
  visible = true,
  opacity = 1,
  rotation = [Math.PI / 2, 0, 0],
}) => {
  const { texture, step } = useMemo(
    () => getCanvas(canvasSize, draw),
    [canvasSize, draw],
  );
  useFrame(() => {
    step();
  });
  return (
    <>
      <group position={position}>
        <mesh rotation={rotation} ref={meshRef}>
          <planeBufferGeometry args={size} />
          <meshBasicMaterial
            map={texture}
            transparent
            visible={visible}
            opacity={opacity}
            attach="material"
          />
        </mesh>
      </group>
    </>
  );
};
